import React from "react";

import { Heading } from "./Heading";
import { CardPopUp } from "./CardPopUp";

interface Props {}

const CardAddDiscordCoach: React.FC<Props> = () => {
  return (
    <>
      <Heading
        variant={"h6"}
        style={{
          display: "flex",
          justifyContent: "flex-end",
          transform: "translateX(-10px)",
        }}
      >
        {/* <label style={styles.label}>Como eu começo?</label> */}x
      </Heading>
      <CardPopUp
        md={3}
        xs={4}
        pathName=""
        title="Clique no botão abaixo para copiar automaticamente o link de embed"
        description={[
          "Clique no botão abaixo para copiar automaticamente o link de embed",
        ]}
        // button="Como funciona"
      ></CardPopUp>
      <CardPopUp
        md={3}
        xs={4}
        pathName=""
        title="Plug o bot no servidor"
        description={[
          "5 perguntas por dia",
          "Sem histórico de interações",
          "Perguntas públicas",
        ]}
        // button="Como funciona"
      ></CardPopUp>
      <CardPopUp
        md={3}
        xs={4}
        pathName=""
        title="Divulgue o novo bot e convide para usá-lo"
        description={["Divulgue o novo bot e convide para usá-lo"]}
        // button="Como funciona"
      ></CardPopUp>
      <CardPopUp
        md={3}
        xs={4}
        pathName=""
        title="Não se esqueça"
        description={["Digite:", "/ask"]}
        // button="Como funciona"
      ></CardPopUp>
    </>
  );
};

export default CardAddDiscordCoach;
